module.exports = __webpack_public_path__ + "static/img/school-5.6f4be07.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-5.png
// module id = MdJF
// module chunks = 0